// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.note-select-row {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.note-out-of {
  margin-left: 0.5rem;
}

.text-other-user {
  max-height: 200px;
  overflow-y: auto;
  padding: 10px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background-color: rgba(215, 217, 217, 0.20);;
  margin-bottom: 10px;
  white-space: pre-wrap;
  word-break: break-word;
}

.text-other-user.finance {
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/composants/AnalyseOffreTechnique/AnalyseOffreTechnique.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".note-select-row {\n  margin-top: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.note-out-of {\n  margin-left: 0.5rem;\n}\n\n.text-other-user {\n  max-height: 200px;\n  overflow-y: auto;\n  padding: 10px;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  background-color: rgba(215, 217, 217, 0.20);;\n  margin-bottom: 10px;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.text-other-user.finance {\n  text-align: right;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
